import DocumentMeta from "react-document-meta";

const { useLocation, Link } = require("react-router-dom");
const menu = require("../../hooks/menu.json");
const productos = require("../../hooks/productos.json");
const { useState, useEffect } = require("react");

const Aplicacion = () => {
  const { pathname } = useLocation();
  const [data, setData] = useState({});
  const [parent, setParent] = useState({});
  const [productosData, setProductosData] = useState([]);
  const [meta, setMeta] = useState({});

  const findAppById = (m, id) => {
    if (m.id === id) {
      return m;
    }
    if (m.items) {
      for (let i = 0; i < m.items.length; i++) {
        let item = findAppById(m.items[i], id);
        if (item) {
          return item;
        }
      }
    }
  };

  useEffect(() => {
    setParent({});
    let id = pathname.split("/").pop();
    let sup = findAppById(
      menu[1],
      pathname.split("/")[pathname.split("/").length - 2]
    );
    if (sup) setParent(sup);
    let item = findAppById(menu[1], id);
    if (item) {

      setMeta({
        title: item.name || "Aplicaciones",
        description: item.content || "Aplicaciones",
        canonical: "https://" + window.location.host + pathname,
        meta: {
          charset: "utf-8",
          name: {
            keywords: `aplicaciones, ${item.name}, ${item.content}`,
          },
        },
      });

      setData(item);
      let prods = productos.filter((p) =>
        p.applications.find((a) => a.id === item.id)
      );
      setProductosData(prods);
    }
  }, [pathname]);

  return (
    <DocumentMeta {...meta}>
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>{parent.name || "Aplicaciones"}</h1>
            <p className="text-info">{data.name || ""}</p>
          </div>
        </div>
        <div className="bg-image">
          <img
            src={
              process.env.PUBLIC_URL +
              "/assets/img/banner/title_" +
              (parent.id || "agroindustria") +
              ".jpg"
            }
            alt=""
          />
        </div>
      </div>
      <div className="service-single-area pt-100">
        <section id="services" className="service-section-three">
          <div className="container">
            <div className="top-content">
              <div className="title">
                <span className="sub-title">{parent.name}</span>
                <h2>{data.name}</h2>
              </div>
              <p>{data.content}</p>
              <div
                className="rounded-image"
                style={{
                  width: "250px",
                  height: "250px",
                  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/aplicaciones/${data.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "50%",
                  float: "left",
                  marginLeft: "15px",
                  marginTop: "20px",
                }}
              ></div>
            </div>
          </div>
        </section>
      </div>
      {(productosData.length>0) ?
      <h3 className="text-center text-primary m-5">
        Productos para esta aplicación
      </h3>
      :
      <></>
      }
      <section id="projects" className="projects-section-three">
        <div className="container">
          <div className="row">
            {productosData.map((producto) => (
              <div className="content-area pb-70 mt-4">
                <div className="container">
                  <div className="row align-items-center career-apply-box">
                    <div className="col-lg-3 col-md-12">
                      <div className="image">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/img/productos/" +
                            producto.gallery[0].image
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-9 col-md-12">
                      <div className="content">
                        <h2>{producto.title}</h2>
                        <p>
                          <b>
                            {(
                              producto.applications.find(
                                (a) => a.id == data.id
                              ) || {}
                            ).content || data.content}
                          </b>
                        </p>
                        <Link
                          to={"/productos/" + parent.id + "/" + producto.id}
                          className="primary-btn"
                        >
                          más info
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </DocumentMeta>
  );
};

export default Aplicacion;
